import { __awaiter } from "tslib";
import { axiosClient } from '@as-react/common-utils';
import { isNullOrUndefined } from '@as-react/common-utils';
class PromotionAPI {
    constructor() {
        this.getProductBundle = (servicesEndpointUrl, defaultRequestParameters, productId, colourId) => {
            return new Promise((resolve, reject) => {
                const axiosConfig = {
                    url: `${servicesEndpointUrl}api/promotion/productbundle/`,
                    method: 'GET',
                    params: {
                        mainWebshop: defaultRequestParameters.mainWebshop,
                        shopId: defaultRequestParameters.shopId,
                        language: defaultRequestParameters.language,
                        productId,
                        colourId,
                    },
                };
                axiosClient.request(axiosConfig).then(response => {
                    if (!isNullOrUndefined(response.data) && !isNullOrUndefined(response.data)) {
                        resolve(response.data);
                    }
                    reject();
                }, reject);
            });
        };
        this.calculateProductBundle = (servicesEndpointUrl, defaultRequestParameters, data) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                url: `${servicesEndpointUrl}api/promotion/productbundle/calculate`,
                params: {
                    mainWebshop: defaultRequestParameters.mainWebshop,
                    shopId: defaultRequestParameters.shopId,
                    language: defaultRequestParameters.language,
                },
                data,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
    }
}
export default new PromotionAPI();
